export const NOTE_FORMATTING = [
  {
    value: "paragraph",
    label: "Paragraph Format",
    example: `The client presents as well-groomed, alert, and oriented to time, place, and person. There is no apparent psychomotor agitation. Speech is coherent, goal-directed, and of normal rate and volume. Mood is described as "anxious" and affect is broadly congruent with mood. The client denies auditory or visual hallucinations and there are no evident delusional thought processes observed. Cognitive functions such as memory, concentration, and attention appear intact during the interview. The client reports difficulty sleeping but no changes in appetite or weight.`,
  },
  {
    value: "bullet",
    label: "Bullet point Format",
    example: `<ul>
    <li>Well-groomed appearance</li>
    <li>Alert and oriented to time, place, and person</li>
    <li>No psychomotor agitation observed</li>
    <li>Speech: coherent, goal-directed, normal rate and volume</li>
    <li>Mood: self-described as "anxious"</li>
    <li>Affect broadly congruent with stated mood</li>
    <li>Denies auditory or visual hallucinations</li>
    <li>No delusional thought processes evident</li>
    <li>Cognitive functions (memory, concentration, attention) appear intact</li>
    <li>Reports difficulty sleeping</li>
    <li>No significant changes in appetite or weight</li>
</ul>`,
  },
];

export const NOTE_TONE = [
  {
    value: "objective",
    label: "Objective",
    example: `The client presents as well-groomed, alert, and oriented to time, place, and person. There is no apparent psychomotor agitation. Speech is coherent, goal-directed, and of normal rate and volume. Mood is described as "anxious" and affect is broadly congruent with mood. The client denies auditory or visual hallucinations and there are no evident delusional thought processes observed. Cognitive functions such as memory, concentration, and attention appear intact during the interview. The client reports difficulty sleeping but no changes in appetite or weight.`,
  },
  {
    value: "analytical",
    label: "Analytical",
    example: `Upon observation, the client exhibits grooming and hygiene consistent with societal norms, suggesting awareness of social standards. Their alertness and orientation to time, place, and person imply intact cognitive functioning in these domains. Speech patterns are within normal parameters; however, the self-described "anxious" mood could indicate underlying anxiety disorders. The absence of psychomotor abnormalities, hallucinations, and delusional thoughts rules out certain psychotic features. Cognitive assessments show no discernible deficits, though reported sleep disturbances could be a factor impacting overall mental health and warrant further investigation.`,
  },
  {
    value: "compassionate",
    label: "Compassionate",
    example: `The client, who made an effort to be well-groomed, shared their experiences with a sense of awareness and presence. They showed no signs of restlessness or lethargy, which is reassuring. Their speech, clear and purposeful, conveyed a sense of anxiety, a feeling they bravely voiced. It's heartening to note the absence of hallucinations or delusions in their experience. Despite these challenges, they demonstrate resilience, maintaining their cognitive abilities. However, their struggle with sleep is concerning and highlights an area where support could be immensely beneficial.`,
  },
  {
    value: "descriptive",
    label: "Descriptive",
    example: `The client enters the room neatly dressed, with a demeanor that is both attentive and composed. They exhibit a full presence, being completely oriented in the here and now. Their speech flows easily, each word carefully selected and articulated, mirroring the anxiety they express feeling. There's a noticeable absence of any fidgeting or slowness in movement, suggesting a stable psychomotor state. While they deny experiencing any hallucinatory phenomena, there's a palpable undercurrent of worry in their voice. Cognitive tasks are handled with an admirable sharpness, though they mention a significant struggle with getting adequate rest, a detail that paints a fuller picture of their current state.`,
  },
];

export const NOTE_VERBOSITY = [
  {
    value: "concise",
    label: "Concise",
    note: "(1-3 sentences per section)",
    example:
      "The client is neatly dressed and appears their stated age. They maintain good eye contact and their speech is clear and coherent. The client demonstrates a full range of affect and their mood is congruent with the content of speech.",
  },

  {
    value: "moderate",
    label: "Moderate",
    note: "(3-7 sentences per section)",
    example: `The client presents as well-groomed, alert, and oriented to time, place, and person. There is no apparent psychomotor agitation or retardation. Speech is coherent, goal-directed, and of normal rate and volume. Mood is described as "anxious" and affect is broadly congruent with mood. The client denies auditory or visual hallucinations and there are no evident delusional thought processes observed. Cognitive functions such as memory, concentration, and attention appear intact during the interview. The client reports difficulty sleeping but no changes in appetite or weight.`,
  },
  {
    value: "detailed",
    label: "Detailed",
    note: "(7+ sentences per section)",
    example: `The client, a 30-year-old individual, appears their stated age and is dressed appropriately for the season and setting. They exhibit good personal hygiene. Eye contact is intermittent, and the client appears restless during the session, frequently changing positions. Speech is rapid and sometimes tangential, requiring redirection at times. The client expresses feelings of hopelessness and describes their mood as "generally low," with affect appearing flat and occasionally incongruent with the stated mood. They report auditory hallucinations, primarily at night, and express paranoid thoughts about being monitored at work. Cognitive assessments indicate some impairment in short-term memory and difficulty concentrating. Insight and judgment appear limited. The client mentions irregular eating habits and significant insomnia. Physical observations include a slight tremor in the hands and evidence of recent, superficial self-harm on forearms.`,
  },
];

export const SERVICE_PROVIDER_DEFAULT = [
  {
    value: "Author",
    label: "Author",
  },
  {
    value: "Clinician",
    label: "Clinician",
  },
  {
    value: "Coach",
    label: "Coach",
  },
  {
    value: "Dr. Last_Name",
    label: "Dr. Last_Name",
  },
  {
    value: "First Name",
    label: "First Name",
  },
  {
    value: "Orchid_Clinician_Preferred_Name",
    label: "Orchid_Clinician_Preferred_Name",
  },
  {
    value: "Physician",
    label: "Physician",
  },
  {
    value: "Provider",
    label: "Provider",
  },
  {
    value: "Therapist",
    label: "Therapist",
  },
];

export const SERVICE_RECEIVER_DEFAULT = [
  {
    value: "Client",
    label: "Client",
  },
  {
    value: "First Name",
    label: "First Name",
  },
  {
    value: "Member",
    label: "Member",
  },
  {
    value: "Patient",
    label: "Patient",
  },
  {
    value: "Client's Preferred Name",
    label: "Client's Preferred Name",
  },
];
